import React, { useState } from 'react';
import { Button, Icon } from '@tencent/spaui';
import { post } from 'store/request';
import { hideDialog, showDialog } from 'components/dialog';
import { report } from 'store/report';
import { useTypedSelector, useAppDispatch } from 'store/index';
import { setAuthBindStatus } from 'store/user';

interface Props {
  className?: string;
  displayType?: 'default' | 'primary' | 'info' | 'warning' | 'link';
  client_id: string;
  loading?: boolean;
  disabled?: boolean;
  onFinish: () => void;
  btnType?: 'button' | 'span';
}

// eslint-disable-next-line react/display-name
export default (props: Props) => {
  const { disabled, className, displayType, client_id, btnType } = props;
  const [loading, setLoading] = useState(props.loading);
  const {
    user: { user },
  } = useTypedSelector((state) => state);
  const dispatch = useAppDispatch();

  const addApp = () => {
    if (loading) {
      return;
    }
    report({ event: 'user_client_bind', client_id });
    post('/user_client_bind/add', { user_id: user.user_id, client_id })
      .then(() => {
        showDialog({
          className: 'auth-success',
          content: (
            <>
              <Icon name="check-filled" />
              <div className="text-bold">应用已成功添加到服务商系统工具栏</div>
              <span className="rect-button light" role="button" onClick={() => hideDialog()}>
                完成
              </span>
            </>
          ),
        });
        props.onFinish();
        dispatch(
          setAuthBindStatus({
            id: client_id,
            client_bind_status: true,
          })
        );
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  if (btnType === 'span') {
    return (
      <span
        className={className}
        role="button"
        onClick={() => {
          addApp();
        }}
      >
        添加应用
      </span>
    );
  }

  return (
    <Button
      loading={loading}
      disabled={disabled}
      className={className}
      displayType={displayType}
      onClick={(e: MouseEvent) => {
        e.preventDefault();
        addApp();
      }}
    >
      添加应用
    </Button>
  );
};
